import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// LABOUR PAY REVISION VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify Labour Pay Revision Inbox (GET)
export const getVerifyLBPayRevision = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            RoleId: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyLBPayRevision?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Labour Pay Revision by Reference Number (GET)
export const getLBPayRevisionbyRefno = async (params) => {
    try {
        const { transactionRefno } = params;
         // DEBUG
        
        // Validate required parameters
        if (!transactionRefno) {
            throw new Error('TransactionRefno is required');
        }
        
        const queryParams = new URLSearchParams({
            TransactionRefno: transactionRefno.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetLBPayRevisionbyRefno?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve Labour Pay Revision (PUT)
export const approveLBPayRevision = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.LabourId) {
            throw new Error('LabourId is required');
        }
        if (!params.TransactionRefNo) {
            throw new Error('TransactionRefNo is required');
        }
        if (!params.Roleid) {
            throw new Error('Roleid is required');
        }
        if (!params.CreatedBy) {
            throw new Error('CreatedBy is required');
        }
        if (!params.Action) {
            throw new Error('Action is required');
        }
        
        const payload = {
            LabourId: params.LabourId.toString().trim(),
            Month: params.Month ? parseInt(params.Month) : 0,
            Year: params.Year ? parseInt(params.Year) : 0,
            TransactionRefNo: params.TransactionRefNo.toString().trim(),
            RevisionNo: params.RevisionNo ? parseInt(params.RevisionNo) : 0,
            HeadsJsonString: params.HeadsJsonString?.toString().trim() || '',
            Roleid: parseInt(params.Roleid),
            CreatedBy: params.CreatedBy.toString().trim(),
            Action: params.Action.toString().trim(),
            Note: params.Note?.toString().trim() || ''
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveLBPayRevision`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};